export const PROFILE_IMAGE_ACCEPT = ".jpg,.jpeg,.png,.webp";

export const PROFILE_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
] as const;

export const PROFILE_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp"] as const;

export const PROFILE_IMAGE_MAX_SIZE_BYTES = 5 * 1024 * 1024;

const getFileExtension = (fileName: string) =>
  fileName.split(".").pop()?.toLowerCase() || "";

export const validateProfileImageFile = (file: File): string | null => {
  const extension = getFileExtension(file.name);
  const mimeType = file.type.toLowerCase();
  const isValidType =
    PROFILE_IMAGE_MIME_TYPES.includes(
      mimeType as (typeof PROFILE_IMAGE_MIME_TYPES)[number],
    ) ||
    PROFILE_IMAGE_EXTENSIONS.includes(
      extension as (typeof PROFILE_IMAGE_EXTENSIONS)[number],
    );

  if (!isValidType) {
    return "Please upload a JPG, JPEG, PNG, or WEBP image.";
  }

  if (file.size > PROFILE_IMAGE_MAX_SIZE_BYTES) {
    return "Image must be 5 MB or smaller.";
  }

  return null;
};
